import { AxiosError } from "axios";

import { BaseApiError } from "./BaseApiError";

export interface NotFoundError extends AxiosError<string> {}

export class NotFoundError extends BaseApiError {
  constructor(error: AxiosError<string>) {
    super();
  }
}
